import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { cancelOtherReason } from '../CancelAppointmentReasons.js';
import { CancelAppointmentReasonTextarea } from '../CancelAppointmentReasonTextarea.js';

const useGetCancellationQuestions = ({ configuration , textareaLabel , errorValidation  })=>{
    const { getLabel  } = useIntl();
    return configuration === null || configuration === void 0 ? void 0 : configuration.map((value)=>{
        if (value === cancelOtherReason) {
            return {
                value,
                label: getLabel(`appointments.page.cancel.${value}`),
                content: /*#__PURE__*/ React.createElement(CancelAppointmentReasonTextarea, {
                    label: textareaLabel,
                    errorValidation: errorValidation
                })
            };
        }
        return {
            value,
            label: getLabel(`appointments.page.cancel.${value}`)
        };
    });
};

export { useGetCancellationQuestions };
//# sourceMappingURL=use-get-cancellation-questions.js.map
